export const setCyclesStatisticsCharts = (statisticsCharts) => {
	return {
		type: 'SET_CYCLES_STATISTICS_CHARTS',
		statisticsCharts
	};
};

export const setCyclesActiveTab = (activeTab) => {
	return {
		type: 'SET_CYCLES_ACTIVE_TAB',
		activeTab
	};
};

export const resetCyclesStatisticsCharts = () => {
	return {
		type: 'RESET_CYCLES_STATISTICS_CHARTS'
	};
};
